import script from "./detail.vue?vue&type=script&setup=true&lang=ts"
export * from "./detail.vue?vue&type=script&setup=true&lang=ts"

import "./detail.vue?vue&type=style&index=0&id=54837844&scoped=true&lang=scss"
import "./detail.vue?vue&type=style&index=1&id=54837844&lang=scss"

import exportComponent from "D:\\otimes-en\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54837844"]])

export default __exports__